export const minimumChatacters = 2;

export const warningSearchMessage = `Insert more than ${minimumChatacters} characters to perform the search`;
